import { render, staticRenderFns } from "./teacherCampusUpdate.vue?vue&type=template&id=e10a80f8&scoped=true"
import script from "./teacherCampusUpdate.vue?vue&type=script&lang=js"
export * from "./teacherCampusUpdate.vue?vue&type=script&lang=js"
import style0 from "./teacherCampusUpdate.vue?vue&type=style&index=0&id=e10a80f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10a80f8",
  null
  
)

export default component.exports